import React from 'react';
import cx from 'classnames';

export default function LayoutPreview() {
  return (
    <div
      className={cx([
        'absolute v2-bg-neutral-900 top-0 bottom-0 left-0 right-0 m-auto rounded-full',
        'w-[120px] h-[32px] leading-8 v2-text-white v2-text-sm opacity-50',
      ])}
    >
      Layout Preview
    </div>
  );
}
